import { render, staticRenderFns } from "./gallery_overlay.vue?vue&type=template&id=989cfbb6&scoped=true"
import script from "./gallery_overlay.vue?vue&type=script&lang=js"
export * from "./gallery_overlay.vue?vue&type=script&lang=js"
import style0 from "./gallery_overlay.vue?vue&type=style&index=0&id=989cfbb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989cfbb6",
  null
  
)

export default component.exports